import { lengthBetweenTwoPoints } from './index';

export interface IPoint {
    x: number;
    y: number;
}
export const ADSORP_ANGLE = 45;
export const ADSORP_RANGE = 2;
export const POINT_ADSORP_RANGE = 10;
/**
 * 计算两个点形成的角度
 * @param P1
 * @param P2
 * @returns angle
 */
export function computeAngle(p1: IPoint, p2: IPoint): number {
    let angle = Math.atan((p1.y - p2.y) / (p1.x - p2.x)) * 180 / Math.PI;
    if (p1.x < p2.x) {
        angle = 180 + angle;
    } else if (p1.x > p2.x) {
        angle = (360 + angle) % 360;
    } else {
        if (p1.y < p2.y) {
            angle = 270;
        } else {
            angle = 90;
        }
    }
    return angle;
}

/**
 * 计算角度相对于可吸附角度的余数
 * @param angle
 * @param adsorpAngle  吸附角度
 * @param adsorpRange  吸附范围
 */
export function computeAngleReaminder(angle: number, adsorpAngle: number, adsorpRange: number): number {
    let rotateAngleRemainder = angle % adsorpAngle;
    if (rotateAngleRemainder > adsorpRange) {
        rotateAngleRemainder -= adsorpAngle;
    }
    return rotateAngleRemainder;
}

/**
 * 计算吸附的角度和吸附点相对于固定点的偏移量x,y
 * @param currentP
 * @param fixP
 * @param adsorpAngle  吸附角度
 * @param adsorpRange  吸附范围
 * @returns { newAngle, x, y }
 */
export function computeOffsetVariables(
    currentP: IPoint,
    fixP: IPoint,
    adsorpAngle: number,
    adsorpRange: number,
): IPoint {
    const lineLen = lengthBetweenTwoPoints(currentP, fixP);
    // 需要吸附到的角度
    let newAngle;
    const angle = computeAngle(currentP, fixP);
    const rotateAngleRemainder = computeAngleReaminder(angle, adsorpAngle, adsorpRange);
    if (rotateAngleRemainder >= 0) {
        newAngle = (Math.floor(angle / adsorpAngle) * adsorpAngle) % 360;
    } else {
        newAngle = ((Math.floor(angle / adsorpAngle) + 1) * adsorpAngle) % 360;
    }
    const x = Math.cos(newAngle / 180 * Math.PI) * lineLen;
    const y = Math.sin(newAngle / 180 * Math.PI) * lineLen;
    return { x, y };
}

/**
 * 计算移动点吸附后的坐标相对于原始坐标的offset
 * @param fixP
 * @param movwP
 * @param x
 * @param y
 * @param newAngle
 */
export function computeAdsorpOffset(fixP: IPoint, moveP: IPoint, x: number, y: number): IPoint {
    const offset = {
        x: 0,
        y: 0,
    };
    // 吸附后坐标
    const newPoint = {
        x: 0,
        y: 0,
    };
    newPoint.x = fixP.x + x;
    newPoint.y = fixP.y + y;
    offset.x = newPoint.x - moveP.x;
    offset.y = newPoint.y - moveP.y;
    return offset;
}

/**
 * 判断移动点是否在吸附点的吸附范围内,100%时吸附范围为5px,吸附范围随着缩放比变化
 * @param fixP
 * @param moveP
 */
export function pointInAdsorpRange(fixP: IPoint, moveP: IPoint, scale: number): boolean {
    const len = lengthBetweenTwoPoints(fixP, moveP);
    if (len <= POINT_ADSORP_RANGE * scale) {
        return true;
    }
    return false;
}

/**
 * 获取当前位置相对于中心点的角度变化
 * @param startPos 起始位置
 * @param centerPos 中心点
 * @param currentPos 当前位置
 * @returns
 */
export function calculateOffsetAngle(startPos: IPoint, centerPos: IPoint, currentPos: IPoint): number {
    const startAngle = Math.atan2(startPos.y - centerPos.y, startPos.x - centerPos.x);
    const angle = Math.atan2(currentPos.y - centerPos.y, currentPos.x - centerPos.x);
    return Math.round((angle - startAngle) * (180 / Math.PI));
}
